// based on Joy-v2 media queries (see 0_variables/breakpoints/_breakpoints.scss)
const bpScreenTinyMax = 359;
const bpScreenXxsMin = bpScreenTinyMax + 1;
const bpScreenXxsMax = 479;
const bpScreenXsMin = bpScreenXxsMax + 1;
const bpScreenXsMax = 767;
const bpScreenSmMin = bpScreenXsMax + 1;
const bpScreenSmMax = 991;
const bpScreenMdMin = bpScreenSmMax + 1;
const bpScreenMdMax = 1199;
const bpScreenLgMin = bpScreenMdMax + 1;
const bpScreenLgMax = 1599;
const bpScreenXlgMin = bpScreenLgMax + 1;

function screenTiny() {
    return window.matchMedia(`(max-width: ${bpScreenTinyMax}px)`).matches;
}

function screenXxs(range = 'max') {
    if (range === 'only') {
        return window.matchMedia(`(min-width: ${bpScreenXxsMin}) and (max-width: ${bpScreenXxsMax}px)`).matches;
    } else if (range === 'min') {
        return window.matchMedia(`(min-width: ${bpScreenXxsMin}px)`).matches;
    } else {
        return window.matchMedia(`(max-width: ${bpScreenXxsMin}px)`).matches;
    }
}

function screenXs(range = 'max') {
    if (range === 'only') {
        return window.matchMedia(`(min-width: ${bpScreenXsMin}) and (max-width: ${bpScreenXsMax}px)`).matches;
    } else if (range === 'min') {
        return window.matchMedia(`(min-width: ${bpScreenXsMin}px)`).matches;
    } else {
        return window.matchMedia(`(max-width: ${bpScreenXsMin}px)`).matches;
    }
}

function screenSm(range = 'max') {
    if (range === 'only') {
        return window.matchMedia(`(min-width: ${bpScreenSmMin}px) and (max-width: ${bpScreenSmMax}px)`).matches;
    } else if (range === 'min') {
        return window.matchMedia(`(min-width: ${bpScreenSmMin}px)`).matches;
    } else {
        return window.matchMedia(`(max-width: ${bpScreenSmMin}px)`).matches;
    }
}

function screenMd(range = 'max') {
    if (range === 'only') {
        return window.matchMedia(`(min-width: ${bpScreenMdMin}) and (max-width: ${bpScreenMdMax}px)`).matches;
    } else if (range === 'min') {
        return window.matchMedia(`(min-width: ${bpScreenMdMin}px)`).matches;
    } else {
        return window.matchMedia(`(max-width: ${bpScreenMdMin}px)`).matches;
    }
}

function screenLg(range = 'max') {
    if (range === 'only') {
        return window.matchMedia(`(min-width: ${bpScreenLgMin}) and (max-width: ${bpScreenLgMax}px)`).matches;
    } else if (range === 'min') {
        return window.matchMedia(`(min-width: ${bpScreenLgMin}px)`).matches;
    } else {
        return window.matchMedia(`(max-width: ${bpScreenLgMin}px)`).matches;
    }
}

// Over 1599 px width
function screenXlg() {
    return window.matchMedia(`(min-width: ${bpScreenXlgMin}px)`).matches;
}

export {screenLg, screenMd, screenTiny, screenSm, screenXlg, screenXs, screenXxs};
